module.exports = __webpack_public_path__ + "baee3a68151f64c4658880e149ce719d.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/termine/Diskofieber.jpg
// module id = 558
// module chunks = 0